import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {PrimeNG, providePrimeNG} from 'primeng/config';
import {AppTheme} from './app.theme';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {MessageService} from 'primeng/api';
import {provideOAuthClient} from 'angular-oauth2-oidc';
import {AuthInterceptor} from './core/interceptors/auth-interceptor';
import {networkErrorInterceptor} from './core/interceptors/network-error.interceptor';
import {DialogService} from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: 'none'
        },

      },
      translation: {
        // Filtros
        startsWith: 'Começa com',
        contains: 'Contém',
        notContains: 'Não contém',
        endsWith: 'Termina com',
        equals: 'Igual a',
        notEquals: 'Diferente de',
        noFilter: 'Sem filtro',
        lt: 'Menor que',
        lte: 'Menor ou igual a',
        gt: 'Maior que',
        gte: 'Maior ou igual a',
        dateIs: 'É igual a',
        dateIsNot: 'Não é igual a',
        dateBefore: 'Antes de',
        dateAfter: 'Depois de',

        // Botões e ações
        clear: 'Limpar',
        apply: 'Aplicar',
        matchAll: 'Combinar todos',
        matchAny: 'Combinar qualquer',
        addRule: 'Adicionar regra',
        removeRule: 'Remover regra',
        accept: 'Sim',
        reject: 'Não',
        choose: 'Selecionar',
        upload: 'Enviar',
        cancel: 'Cancelar',
        pending: 'Pendente',

        // Tamanhos de arquivo
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],

        // Calendário
        dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: [
          'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
          'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
        ],
        monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        chooseYear: 'Selecionar ano',
        chooseMonth: 'Selecionar mês',
        chooseDate: 'Selecionar data',
        prevDecade: 'Década anterior',
        nextDecade: 'Próxima década',
        prevYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        prevMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        prevHour: 'Hora anterior',
        nextHour: 'Próxima hora',
        prevMinute: 'Minuto anterior',
        nextMinute: 'Próximo minuto',
        prevSecond: 'Segundo anterior',
        nextSecond: 'Próximo segundo',

        // DataTable
        emptyMessage: 'Nenhum registro encontrado',
        emptyFilterMessage: 'Nenhum registro corresponde ao filtro aplicado',
        emptySearchMessage: 'Nenhum registro encontrado',
        emptySelectionMessage: 'Nenhum registro encontrado',
        noFileChosenMessage: 'Nenhum arquivo selecionado',
        fileChosenMessage: '{0} arquivos selecionados',

        selectionMessage: '{0} opções selecionadas',
      }
    }),
    PrimeNG,
    MessageService,
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([networkErrorInterceptor]),
    ),
    provideOAuthClient(),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    DialogService,
    {provide: LOCALE_ID, useValue: 'pt'},
  ]
};
